import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import type { Orden } from '@/shared/lib/tablaOrden';

/**
 * Encabezado de tabla que ordena al hacer click (asc → desc → sin orden).
 * Va con `useOrdenTabla`. `className` es la del `<th>` de cada tabla
 * (padding, ancho, `text-right` en las columnas de importes).
 */
export function SortableTh<K extends string>({
  label,
  sortKey,
  orden,
  onSort,
  className,
}: {
  label: React.ReactNode;
  sortKey: K;
  orden: Orden<K>;
  onSort: (key: K) => void;
  className?: string;
}) {
  const activo = orden?.key === sortKey ? orden.dir : null;
  const Icono = activo === 'asc' ? ArrowUp : activo === 'desc' ? ArrowDown : ArrowUpDown;
  const derecha = /\btext-right\b/.test(className ?? '');
  return (
    <th
      className={className}
      aria-sort={activo === 'asc' ? 'ascending' : activo === 'desc' ? 'descending' : 'none'}
    >
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        title="Ordenar"
        className={cn(
          'group inline-flex items-center gap-1 uppercase tracking-wide transition-colors hover:text-foreground',
          derecha && 'flex-row-reverse',
          activo && 'text-foreground',
        )}
      >
        {label}
        <Icono
          className={cn('h-3.5 w-3.5 shrink-0', !activo && 'opacity-40 group-hover:opacity-80')}
          aria-hidden
        />
      </button>
    </th>
  );
}
